import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const styles_select = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    container: (provided) => ({ ...provided }),
    control: (provided) => ({ ...provided, paddingTop: '5px', paddingBottom: '5px' }),
    valueContainer: (provided) => ({ ...provided, overflow: 'visible', marginTop: '10px' }),
    placeholder: (provided, state) => ({
        ...provided,
        position: 'absolute',
        top: state.hasValue || state.selectProps.inputValue ? -15 : '0%',
        transition: 'top 0.1s, font-size 0.1s',
        fontSize: (state.hasValue || state.selectProps.inputValue) && 13
    })
};

const opcionesStatus = [
    { value: true, label: 'Finalizado' },
    { value: false, label: 'Pendiente' }
];

const FiltrosCorte = ({ show, handleCerrar, filtros, handleAplicar }) => {

    const sucursalesListado = useSelector(state => state.sucursales.listado);
    const empleadosListado = useSelector(state => state.empleados.listado);

    const [folio, setFolio] = useState('');
    const [responsableData, setResponsableData] = useState(null);
    const [sucursalData, setSucursalData] = useState(null);
    const [statusData, setStatusData] = useState(null);
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);

    useEffect(() => {
        if (show) {
            setFolio(filtros.folio || '');
            setStatusData(filtros.status !== null ? opcionesStatus.find(o => o.value === filtros.status) ?? null : null);
            setFechaInicio(filtros.fecha_inicio ? new Date(filtros.fecha_inicio) : null);
            setFechaFin(filtros.fecha_fin ? new Date(filtros.fecha_fin) : null);

            const empOpc = empleadosListado.map(e => ({
                value: e._id,
                label: `${e.nombre || ''} ${e.apellido_paterno || ''} ${e.apellido_materno || ''}`.trim()
            }));
            setResponsableData(filtros.responsable ? empOpc.find(e => e.value === filtros.responsable) ?? null : null);

            const sucOpc = sucursalesListado.map(s => ({ value: s._id, label: s.nombre }));
            setSucursalData(filtros.sucursal ? sucOpc.find(s => s.value === filtros.sucursal) ?? null : null);
        }
    }, [show]);

    const handleAplicarFiltros = () => {
        handleAplicar({
            folio: folio.trim(),
            responsable: responsableData ? responsableData.value : null,
            sucursal: sucursalData ? sucursalData.value : null,
            status: statusData ? statusData.value : null,
            fecha_inicio: fechaInicio ? new Date(new Date(fechaInicio).setHours(0, 0, 0, 0)) : null,
            fecha_fin: fechaFin ? new Date(new Date(fechaFin).setHours(23, 59, 59, 999)) : null
        });
        handleCerrar();
    };

    const handleLimpiar = () => {
        setFolio('');
        setResponsableData(null);
        setSucursalData(null);
        setStatusData(null);
        setFechaInicio(null);
        setFechaFin(null);
        handleAplicar({ folio: '', responsable: null, sucursal: null, status: null, fecha_inicio: null, fecha_fin: null });
        handleCerrar();
    };

    const responsablesOpciones = empleadosListado.map(e => ({
        value: e._id,
        label: `${e.nombre || ''} ${e.apellido_paterno || ''} ${e.apellido_materno || ''}`.trim()
    }));
    const sucursalesOpciones = sucursalesListado.map(s => ({ value: s._id, label: s.nombre }));

    return (
        <Modal show={show} size="lg" backdrop="static" centered onHide={handleCerrar}>
            <Modal.Header closeButton>
                <Modal.Title>Filtros</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row g-3">

                    <div className="col-4">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Folio"
                                id="filtro_folio"
                                value={folio}
                                onChange={e => setFolio(e.target.value)}
                            />
                            <label htmlFor="filtro_folio">Folio</label>
                        </div>
                    </div>

                    <div className="col-4 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Sucursal"
                                options={sucursalesOpciones}
                                value={sucursalData}
                                onChange={option => setSucursalData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-4 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Status"
                                options={opcionesStatus}
                                value={statusData}
                                onChange={option => setStatusData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-6 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Responsable"
                                options={responsablesOpciones}
                                value={responsableData}
                                onChange={option => setResponsableData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>

                    <div className="col-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="filtro_fecha_inicio"
                                    className="form-control text-center input-datepicker"
                                    selected={fechaInicio}
                                    onChange={date => setFechaInicio(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    isClearable
                                    autoComplete="off"
                                />
                                <label className="label-datepicker" htmlFor="filtro_fecha_inicio">Fecha inicio</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="filtro_fecha_fin"
                                    className="form-control text-center input-datepicker"
                                    selected={fechaFin}
                                    onChange={date => setFechaFin(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    isClearable
                                    autoComplete="off"
                                    minDate={fechaInicio}
                                />
                                <label className="label-datepicker" htmlFor="filtro_fecha_fin">Fecha fin</label>
                            </div>
                        </div>
                    </div>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-outline-secondary me-auto" onClick={handleLimpiar}>
                    <i className="fas fa-times me-1"></i> Limpiar
                </button>
                <button className="btn btn-secondary" onClick={handleCerrar}>
                    Cancelar
                </button>
                <button className="btn btn-primary" onClick={handleAplicarFiltros}>
                    <i className="fas fa-filter me-1"></i> Aplicar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default FiltrosCorte;
